"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Link, useNavigate } from "react-router";
import classNames from "classnames";
import styles from "./Error404Page.module.css";
import { ReactComponent as DirigibleCrash } from "./assets/404-dirigible.svg";
import { ReactComponent as Ground } from "./assets/ground.svg";
import { useModulePathResolver } from "./hooks";
export const Error404Page = (props) => {
  const { className } = props;
  const modulePath = useModulePathResolver();
  const navigate = useNavigate();
  const backHandler = useCallback((ev) => {
    ev.preventDefault();
    navigate(-1);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: classNames(styles.root, "pageNotFound", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "errBlock", children: [
      /* @__PURE__ */ jsx("p", { className: classNames(styles.errorCode, "errCode"), children: "404" }),
      /* @__PURE__ */ jsxs("p", { className: classNames(styles.errorMessage, "errMsg"), children: [
        "Mission failure, this page doesn\u2019t exist!",
        /* @__PURE__ */ jsx("br", {}),
        "Let\u2019s go",
        " ",
        /* @__PURE__ */ jsxs("a", { href: "#", onClick: backHandler, children: [
          " ",
          "back",
          " "
        ] }),
        " ",
        "to safety. Or all the way ",
        /* @__PURE__ */ jsx(Link, { to: modulePath("/"), children: "home" }),
        "."
      ] })
    ] }),
    /* @__PURE__ */ jsx(DirigibleCrash, {}),
    /* @__PURE__ */ jsx("div", { className: classNames(styles.errorBackground, "background"), children: /* @__PURE__ */ jsx(Ground, { className: classNames(styles.errorGround, "ground") }) })
  ] });
};
